// extracted by mini-css-extract-plugin
export default {"expandButton":"app-react-components-datatables-ExpandingCell-module__expand-button"};